<template>
  <div class="userCenter">
    <div class="boxCenter">
      <div class="userBox">
        <LeftSide></LeftSide>
        <div class="userRight">
          <div class="userTitle">订单详情</div>
          <div class="subTitle"><span></span>会员信息</div>
          <div class="userInfoBox" style="padding-top: 5px;">
            <el-form ref="form"label-width="161px">
              <el-form-item label="会员姓名">
               <!--  <el-input v-model="orderData.memberName" placeholder="请输入姓名" :disabled="true"></el-input> -->
               {{orderData.memberName}}
              </el-form-item>
              <!-- <el-form-item label="身份证" prop="idNumber">
                <el-input v-model="formData.idNumber" placeholder="请输入身份证" :disabled="true"></el-input>
              </el-form-item> -->
              <el-form-item label="手机号码">
                <!-- <el-input v-model="orderData.phoneNum" placeholder="请输入号码" :disabled="true"></el-input> -->
                {{orderData.phoneNum}}
              </el-form-item>
              <el-form-item label="地址信息">
                <!-- <el-input v-model="orderData.address" placeholder="请输入地址" :disabled="true"></el-input> -->
                {{orderData.address}}
              </el-form-item>
              <el-form-item label="紧急联系人">
                <!-- <el-input v-model="orderData.emergPerson" placeholder="请输入姓名" :disabled="true"></el-input> -->
                {{orderData.emergPerson}}
              </el-form-item>
              <el-form-item label="紧急联系人电话">
                <!-- <el-input v-model="orderData.emergPhone" placeholder="请输入号码" :disabled="true"></el-input> -->
                {{orderData.emergPhone}}
              </el-form-item>
            </el-form>
          </div>
          <div class="subTitle"><span></span>订单信息</div>
          <div class="orderInfo">
            <div class="inforTh">
              <el-row>
                <el-col :span="8" style="text-align: left;">订单编号：{{orderData.orderCode}}</el-col>
                <el-col :span="8" style="text-align: center;">创建时间：{{orderData.createDate?orderData.createDate.substring(0,19):''}}</el-col>
                <el-col :span="8" style="text-align: right;" v-if="orderData.status != 1">付款时间：{{orderData.payTime?orderData.payTime.substring(0,19):''}}</el-col>
              </el-row>
            </div>
            <div class="inforTd">
              <div class="inforTdLeft">
                <div class="imgBox"><router-link :to="'/activitieDetails/'+orderData.travelId"><img :src="orderData.pic"></router-link></div>
              </div>
              <div class="inforTdRight">
                <div class="title">{{orderData.name}}</div>
                <div class="proper">{{orderData.property}}</div>
                <div class="time">活动开始时间：{{orderData.travelDate}}</div>
                <div class="num">
                  <p><span class="span1">报名人数：</span>
                    <span class="span2" v-if="orderData.price > 0 && orderData.num > 0">￥{{orderData.price.toFixed(2)}}</span><span v-if="orderData.price > 0 && orderData.num > 0" class="span3">成人x{{orderData.num}}</span><br  v-if="orderData.price > 0 && orderData.num > 0">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span class="span2" v-if="orderData.childPrice > 0 && orderData.childNum > 0">￥{{orderData.childPrice.toFixed(2)}}</span><span v-if="orderData.childPrice > 0 && orderData.childNum > 0" class="span3">儿童x{{orderData.childNum}}</span></p>
                </div>
                <div class="price">订单总价：<p class="spanInlineBox"><span>￥{{orderData.total.toFixed(2)}}</span></p></div>

                <div class="price" v-if="orderData.preferential > 0">积分抵扣：<p class="spanInlineBox"><span>{{orderData.preferential?orderData.preferential.toFixed(2):''}}</span>元（<span>{{orderData.credits}}</span>分）</p></div>

                <div class="price">实付金额：<p class="spanInlineBox"><span>￥{{orderData.pay.toFixed(2)}}</span></p></div>
                <div class="btn" v-if="orderData.status == 1">
                  <span @click="confirmPay">确认支付</span>
                  <span @click="cancelOrder(orderData.id)">取消订单</span>
                </div>
              </div>
              <div class="evaluateBox" v-if="orderData.status != 1" style="padding-top: 20px;">
                <div class="evaluateState">
                  <div class="starBox">
                    <span :class="{'active':starNum>0}" @click="selectStar(1)"></span>
                    <span :class="{'active':starNum>1}" @click="selectStar(2)"></span>
                    <span :class="{'active':starNum>2}" @click="selectStar(3)"></span>
                    <span :class="{'active':starNum>3}" @click="selectStar(4)"></span>
                    <span :class="{'active':starNum>4}" @click="selectStar(5)"></span>
                  </div>
                  <div class="status">订单评价</div>
                </div>
                <div class="evaluateInfo">
                  <el-input
                    type="textarea"
                    placeholder="请输入内容"
                    :rows="3"
                    :disabled="orderData.travelEvaluation"
                    v-model="desc">
                  </el-input>
                </div>
                <div class="evaluateBtn" v-if="!orderData.travelEvaluation"><span @click="confirmEvaluation">提交</span></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <el-dialog
        title="请微信扫码支付"
        :visible.sync="payBoxVisible"
        width="30%">
        <div>
          <img style="display: block;margin:auto;" :src="payCodeUrl">
        </div>
      </el-dialog> -->
      <div class="zdyPayBox" v-show="payBoxVisible">
        <div class="payContent">
          <p>付款金额为<br><span>{{orderData.pay}}</span>元</p>
          <img style="display: block;margin:auto;" :src="payCodeUrl">
          <span class="close" @click="closePay"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LeftSide from './common/leftside'
  import eventVue from '../bus.js'
  import QRCode from 'qrcode'
  export default {
    components: {
      LeftSide
    },
    data(){
      return {
        orderId:'',
        orderData:{},
        desc:'',
        payCodeUrl:'',
        payBoxVisible:false,
        starNum:0
      }
    },
    computed: {
      userData() {
        return this.$store.state.userData
      }
    },
    created(){
      this.orderId = this.$route.params.id
      this.getOrderObj()
    },
    mounted(){
      eventVue.$emit("leftSwitch",'2')
    },
    methods:{
      //选择评价星星
      selectStar(star){
        if(this.orderData.travelEvaluation){
          return
        }
        this.starNum = star
      },
      statusChange(sta){
        this.status = sta
        this.curPage = 1
        this.getOrderList()
      },
      getOrderObj(){
        this.$https.get('/api/travelOrder/id/'+this.orderId).then((response)=>{
          this.orderData = response.data
          if(response.data.travelEvaluation){
            this.starNum = response.data.travelEvaluation.star
            this.desc = response.data.travelEvaluation.desc
          }
        });
      },

      cancelOrder(id){
        this.$confirm('是否取消该订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //this.$router.go(-1)
          this.$https.post('/api/travelOrder/cancelTravelOrder/id/'+id,{}).then(res => {
            if(res.code == 0){
              this.$message.success("操作成功")
              //this.getOrderList()
              this.$router.go(-1)
            }else{
              this.$message.warning(res.msg)
            }
          });
        }).catch(() => {});
      },
      handleCurrentChange(val){
        this.curPage = val
        this.getOrderList()
      },
      //确认支付生成二维码参数
      confirmPay(){
        this.$https.get(`/api/wechatPay/getNATIVEPay?openid=${this.userData.openidPub}&orderCode=${this.orderData.orderCode}&orderType=2`).then((response)=>{
          QRCode.toDataURL(response.data).then(url => {
            this.payCodeUrl = url
            this.payBoxVisible = true
          }).catch(err => {
            console.warning(err)
          })
        });
      },
      closePay(){
        this.getOrderObj()
        this.payBoxVisible = false
      },
      //评价
      confirmEvaluation(){
        if(this.starNum == 0){
          this.$message.warning('请选择评价星级!')
          return
        }
        if(this.desc == "" || this.desc == null){
          this.$message.warning('请选输入评价内容!')
          return
        }
        let data ={
          desc: this.desc,
          memberId: this.userData.id,
          nickname: this.userData.nickname,
          orderId: this.orderData.id,
          star: this.starNum,
          travelId: this.orderData.travelId
        }

        this.$confirm('提交后评价不能修改，请确认已完成该订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(action => {
            if(action == 'confirm'){
              this.$https.post('/api/travelEvaluation/addTravelEvaluation',data).then((response)=>{
                //this.orderObj = response.data
                this.getOrderObj()
              });
            }
        }).catch(err =>{
        });
      }
    }
  }
</script>

<style scoped>
  .zdyPayBox{
    position: fixed;
    z-index: 9999;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.5);
  }
  .zdyPayBox .payContent{
    width: 684px;
    height: 534px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin: -267px 0 0 -342px;
    background: url("../assets/images/payPop.png");
  }
  .zdyPayBox .payContent p{
    line-height: 28px;
    position: absolute;
    width: 100%;
    left: 0px;
    top: 150px;
    text-align: center;
    font-size: 16px;
    color: #ffffff;
  }
  .zdyPayBox .payContent p span{
    font-size:18px;
    color: #eea10d;
  }
  .zdyPayBox .payContent img{
    width: 210px;
    height: 192px;
    position: absolute;
    top: 221px;
    left: 242px;
  }
  .zdyPayBox .payContent .close{
    display: block;
    position: absolute;
    width: 50px;
    height: 50px;
    top: 38px;
    right: 38px;
    cursor: pointer;
  }
  .spanInlineBox{
    display: inline-block;
    width: 130px;
  }
  .userInfoBox{
    width: 454px;
    padding-top: 24px;
  }
  .editBtn{
    position: absolute;
    color: #5680f9;
    right: 20px;
    top: 14px;
    font-size: 16px;
    cursor: pointer;
  }
  .subTitle{
    padding: 10px 0 0 15px;
    height: 52px;
    line-height: 52px;
    font-size: 18px;
    color: #333333;
  }
  .subTitle span{
    display: inline-block;
    width: 13px;
    height: 13px;
    background: #5680F9;
    border-radius: 50%;
    margin-right: 15px;
  }
  .orderInfo{width: 818px;padding-left: 15px;margin-bottom: 50px;}
  .orderInfo .inforTh{
    padding: 0 25px;
    height: 32px;
    line-height: 32px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    font-size: 12px;
    color: #666666;
  }
  .orderInfo .inforTd{
    padding: 12px;
    background: #FBFBFB;
    border: 1px solid #E5E5E5;
    border-top: 0px;
    position: relative;
    overflow: hidden;
  }
  .inforTdLeft{
    width: 221px;
    float: left;
  }
  .inforTdLeft .imgBox{
    width: 219px;
    background: #FFFFFF;
    border: 1px solid #E5E5E5;
    margin-bottom: 10px;
  }
  .inforTdLeft .imgBox img{
    width: 100%;
    height: 100%;
  }
  .inforTdLeft p{
    line-height: 30px;
    font-size: 14px;
    color: #666666;
  }
  .inforTdRight{
    padding-left: 245px;
    padding-right: 30px;
  }
  .inforTdRight .title{
    height: 40px;
    overflow: hidden;
    font-size: 14px;
    color: #666666;
    line-height: 20px;
  }
  .inforTdRight .proper{
    font-size: 12px;
    color: #919191;
    margin-top: 15px;
  }
  .inforTdRight .time{
    width: 293px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    font-size: 14px;
    color: #5680F9;
    border: 1px solid #5680F9;
    margin-top: 18px;
  }
  .inforTdRight .num{
    line-height: 24px;
    margin-top: 15px;
  }
  .inforTdRight .num .span1{
    font-size: 14px;
    color: #666666;
    display: inline-block;
  }
  .inforTdRight .num .span2{
    color: #919191;
    font-size: 14px;
    width: 80px;
    display: inline-block;
    margin-left: 46px;
  }
  .inforTdRight .num .span3{
    color: #666666;
    font-size: 14px;
    display: inline-block;
  }
  .inforTdRight .price{
    line-height: 30px;
    font-size: 14px;
    color: #666666;
    text-align: right;
  }
  .inforTdRight .price span{
    color: #E50001;
  }
  .inforTdRight .btn{
    text-align: right;
  }
  .inforTdRight .btn span{
    display: inline-block;
    width: 85px;
    height: 27px;
    line-height: 26px;
    text-align: center;
    background: #FFCD30;
    border-radius: 4px;
    color: #FFFEFE;
    font-size: 16px;
    /*position: absolute;
    bottom: 12px;*/
    cursor: pointer;
    margin-top: 20px;
  }
  .evaluateBox{
    clear: both;
  }
  .evaluateBox .evaluateState{
    overflow: hidden;
  }
  .evaluateBox .evaluateState .starBox{
    float: left;
  }
  .evaluateBox .evaluateState .starBox span{
    display: inline-block;
    width: 26px;
    height: 25px;
    background: url("../assets/images/star1.png");
    cursor: pointer;
  }
  .evaluateBox .evaluateState .starBox span.active{
    background: url("../assets/images/start2.png");
  }
  .evaluateBox .evaluateState .status{
    float: right;
    width: 85px;
    height: 27px;
    line-height: 26px;
    text-align: center;
    background: #FFCD30;
    border-radius: 4px;
    color: #FFFEFE;
    font-size: 16px;
    cursor: pointer;
  }
  .evaluateBox .evaluateInfo{
    margin-top: 5px;
  }
  .evaluateBox .evaluateBtn{
    margin-top: 6px;
    text-align: right;
  }
  .evaluateBox .evaluateBtn span{
    display: inline-block;
    width: 60px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: #5680F9;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/components/orderDetail.vue